
import { useEffect, useState } from "react";

export default function ConfigPLCs() {
  const [plcs, setPlcs] = useState([]);
  const [nome, setNome] = useState("");
  const [ip, setIp] = useState("");
  const [rack, setRack] = useState(0);
  const [slot, setSlot] = useState(0);
  const [frequency, setFrequency] = useState(1);
  const [editIndex, setEditIndex] = useState(null);

  useEffect(() => {
    fetch("/plcs")
      .then((res) => res.json())
      .then((data) => setPlcs(data));
  }, []);

  const limparCampos = () => {
    setNome("");
    setIp("");
    setRack(0);
    setSlot(0);
    setFrequency(1);
    setEditIndex(null);
  };

  const adicionarOuEditarPLC = () => {
    if (!nome.trim() || !ip.trim()) return alert("Preencha nome e IP.");

    const novo = { nome, ip, rack, slot, frequency };
    const novaLista = [...plcs];

    if (editIndex !== null) {
      novaLista[editIndex] = novo;
    } else {
      novaLista.push(novo);
    }

    setPlcs(novaLista);
    limparCampos();
  };

  const editarPLC = (index) => {
    const plc = plcs[index];
    setNome(plc.nome);
    setIp(plc.ip);
    setRack(plc.rack);
    setSlot(plc.slot);
    setFrequency(plc.frequency ?? 1);
    setEditIndex(index);
  };

  const removerPLC = (index) => {
    const novaLista = [...plcs];
    novaLista.splice(index, 1);
    setPlcs(novaLista);
    if (editIndex === index) limparCampos();
  };

  const salvar = () => {
    fetch("/plcs", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(plcs),
    }).then(() => alert("PLCs salvos com sucesso."));
  };

  return (
    <div className="p-4 max-w-5xl mx-auto text-white">
      <h2 className="text-2xl font-bold mb-4">🧠 Configurar PLCs</h2>

      <div className="flex flex-wrap gap-4 mb-4">
        <div className="flex flex-col min-w-[140px] flex-1">
          <label className="text-sm">Nome</label>
          <input
            type="text"
            placeholder="Nome"
            value={nome}
            onChange={(e) => setNome(e.target.value)}
            className="bg-gray-800 border border-gray-700 rounded px-3 py-2 w-full"
          />
        </div>
        <div className="flex flex-col min-w-[140px] flex-1">
          <label className="text-sm">IP</label>
          <input
            type="text"
            placeholder="IP"
            value={ip}
            onChange={(e) => setIp(e.target.value)}
            className="bg-gray-800 border border-gray-700 rounded px-3 py-2 w-full"
          />
        </div>
        <div className="flex flex-col min-w-[100px]">
          <label className="text-sm">Rack</label>
          <input
            type="number"
            placeholder="Rack"
            value={rack}
            onChange={(e) => setRack(Number(e.target.value))}
            className="bg-gray-800 border border-gray-700 rounded px-3 py-2 w-full"
          />
        </div>
        <div className="flex flex-col min-w-[100px]">
          <label className="text-sm">Slot</label>
          <input
            type="number"
            placeholder="Slot"
            value={slot}
            onChange={(e) => setSlot(Number(e.target.value))}
            className="bg-gray-800 border border-gray-700 rounded px-3 py-2 w-full"
          />
        </div>
        <div className="flex flex-col min-w-[120px]">
          <label className="text-sm">Frequência (s)</label>
          <input
            type="number"
            placeholder="Frequência"
            step="0.1"
            value={frequency}
            onChange={(e) => setFrequency(Number(e.target.value))}
            className="bg-gray-800 border border-gray-700 rounded px-3 py-2 w-full"
          />
        </div>
        <div className="flex items-end min-w-[120px]">
          <button
            onClick={adicionarOuEditarPLC}
            className={`${
              editIndex !== null ? "bg-yellow-600 hover:bg-yellow-700" : "bg-green-600 hover:bg-green-700"
            } rounded px-4 py-2 w-full md:w-auto`}
          >
            {editIndex !== null ? "✏️ Atualizar" : "➕ Adicionar"}
          </button>
        </div>
      </div>

      <div className="space-y-2 mb-4">
        {plcs.map((plc, index) => (
          <div
            key={index}
            className="flex flex-col md:flex-row justify-between items-start md:items-center bg-gray-800 p-3 rounded"
          >
            <span className="font-mono text-sm">
              {plc.nome} — {plc.ip} (Rack: {plc.rack}, Slot: {plc.slot}, Freq: {plc.frequency ?? "-"}s)
            </span>
            <div className="flex gap-3 mt-2 md:mt-0">
              <button
                onClick={() => editarPLC(index)}
                className="text-yellow-400 hover:text-yellow-500 text-sm"
              >
                ✏️ Editar
              </button>
              <button
                onClick={() => removerPLC(index)}
                className="text-red-400 hover:text-red-600 text-sm"
              >
                ❌ Remover
              </button>
            </div>
          </div>
        ))}
      </div>

      <button
        onClick={salvar}
        className="bg-blue-600 hover:bg-blue-700 rounded px-6 py-2 font-semibold"
      >
        💾 Salvar Configurações
      </button>
    </div>
  );
}
